export const norm=(v)=>String(v??"").trim().toLowerCase();
